/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { connect } from 'react-redux';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  profile,
  setFormData,
  formData,
  createInput,
  createTextArea,
  createSelect,
  createUploader,
  updateUserManagement,
  getUserManagementList,
  showUserManagement,
  history,
  // getRoleList,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      thumbnail: _.get(profile, 'attributes.thumbnail'),
      media: _.get(profile, 'included.media.0.attributes.url'),
      is_active: profile.attributes.is_active || false,
      is_video: profile.attributes.is_video || false,
      // use_url: profile.attributes.is_video || false,
      video_url: _.get(profile, 'included.media.0.attributes.url'),
      title: profile.attributes.title || '',
      author: profile.attributes.author || '',
      post_type: profile.attributes.post_type || '',
      is_featured: profile.attributes.is_featured || false,
      content: profile.attributes.content || '',
      date_posted: profile.attributes.date_posted
        ? `${moment(profile.attributes.date_posted).format('MM-DD-YYYY HH:mm')}`
        : '',
    });
  };
  const handleOnSubmit = e => {
    e.preventDefault();

    if (!_.get(formData, 'media.cdnUrl')) {
      if (!_.get(formData, 'video_url')) {
        Alert.error('Banner is required.');
        return false;
      }
    }

    const args = {
      ...formData,
      method: 'PUT',
      is_video: formData.is_video ? formData.is_video : false,
      thumbnail: formData.thumbnail.cdnUrl
        ? formData.thumbnail.cdnUrl
        : _.get(profile, 'attributes.thumbnail'),
      media: [
        {
          url: _.get(formData, 'media.cdnUrl')
            ? _.get(formData, 'media.cdnUrl')
            : _.get(formData, 'video_url'),
        },
      ],
      date_posted: `${moment(_.get(formData, 'date_posted')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
    };
    return updateUserManagement(profile.id, args, ({ data }) => {
      setModal({ isOpen: false });
      getUserManagementList();
      showUserManagement(profile.id);
      history.push(`/news/articles/${_.get(data, 'id')}`);
      // UpdateInfo();
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const onChange = e => {
    if (e.target.name === 'is_video') {
      setFormData({
        ...formData,
        media: [],
        [e.target.name]:
          e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      });
      return false;
    }
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  // useEffect(() => {
  //   getRoleList();
  // }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              Use Video Banner: &nbsp;
            </label>
            <input
              name="is_video"
              type="checkbox"
              checked={_.get(formData, 'is_video')}
              onChange={onChange}
            />
          </div>
          {_.get(formData, 'is_video') && (
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label">
                Use Video Url: &nbsp;
              </label>
              <input
                name="use_url"
                type="checkbox"
                checked={_.get(formData, 'use_url')}
                onChange={onChange}
              />
            </div>
          )}
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-md-6">
            <div className="col-12">
              {!_.get(formData, 'is_video') ? (
                <>
                  <div className="col-12">
                    <label className="form-control-plaintext form-label">
                      Banner Image:{' '}
                      <span className="text-danger">
                        <i>Required</i>
                      </span>
                    </label>
                  </div>
                  <img
                    className="w-100 rounded"
                    src={
                      !_.isObject(_.get(formData, 'media') || '')
                        ? _.get(formData, 'media') || ImagePlaceholder
                        : _.get(formData, 'media.cdnUrl') || ImagePlaceholder
                    }
                    alt=""
                  />
                  <div className=" form-group">
                    {createUploader(
                      { key: 'media', label: 'Browse' },
                      {
                        required: true,
                        imagesOnly: !_.get(formData, 'is_video') || false,
                      }
                    )}
                  </div>
                </>
              ) : _.get(formData, 'use_url') ? (
                <div className="col-12 form-group">
                  {createInput(
                    { key: 'video_url', label: 'Video URL:' },
                    {
                      required: true,
                      placeholder: 'Enter Video URL',
                      maxLength: '150',
                    }
                  )}
                </div>
              ) : (
                <>
                  <div className="col-12">
                    <label className="form-control-plaintext form-label">
                      Banner Image:{' '}
                      <span className="text-danger">
                        <i>Required</i>
                      </span>
                    </label>
                  </div>
                  <div className="player-wrapper">
                    <ReactPlayer
                      className="react-player"
                      controls
                      url={
                        !_.isObject(_.get(formData, 'media') || '')
                          ? _.get(formData, 'media') || ImagePlaceholder
                          : _.get(formData, 'media.cdnUrl') || ImagePlaceholder
                      }
                      width="100%"
                      height="100%"
                    />
                  </div>
                  <div className=" form-group">
                    {createUploader(
                      { key: 'media', label: 'Browse' },
                      {
                        required: true,
                        imagesOnly: !_.get(formData, 'is_video') || false,
                      }
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="col-12">
              <label className="form-control-plaintext form-label">
                Thumbnail Image:{' '}
                <span className="text-danger">
                  <i>Required</i>
                </span>
              </label>
            </div>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(_.get(formData, 'thumbnail') || '')
                    ? _.get(formData, 'thumbnail') || ImagePlaceholder
                    : _.get(formData, 'thumbnail.cdnUrl') || ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              {createUploader(
                { key: 'thumbnail', label: 'Browse' },
                { required: true, imagesOnly: true }
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'title', label: 'Title:' },
              {
                required: true,
                placeholder: 'Announcement Title',
                maxLength: '150',
              }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'author', label: 'Author:' },
              { required: true, placeholder: 'Name of author', maxLength: '50' }
            )}
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Date Posted:</label>
            <DateInputPicker
              maxDate={new Date()}
              withTime
              className="full-input"
              onChange={handleOnChangeDate('date_posted')}
              value={_.get(formData, 'date_posted') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Post Type: <i className="text-danger">Required</i> &nbsp;
            </label>
            {createSelect(
              {
                required: true,
                placeholder: 'Pick a tag type',
                key: 'post_type',
              },
              c.TAGS
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Feature: &nbsp;
            </label>
            <input
              name="is_featured"
              type="checkbox"
              checked={_.get(formData, 'is_featured')}
              onChange={onChange}
            />
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'content', label: 'Content:' },
              { required: true, placeholder: 'Place content here' }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Publish Immediately: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createSelect: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  // UpdateInfo: PropTypes.instanceOf(Function).isRequired,
  // getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
